"use client";

import { PageHero } from "@widgets/page-hero";

import { ArticleCard } from "@entities/article-card";

import cardsGrid from "@shared/ui/cards-grid/cards-grid.module.scss";
import { FilterPaginationContainer } from "@shared/ui/filter-pagination-container/filter-pagination-container";

import type { NewsListType } from "@/_pages/news/model";
import type { NewsPageType } from "@/_pages/news/model/types";

import { getCurrentBlogPosts } from "../api";

import s from "./blog-page.module.scss";

export type BlogPageProps = {
  content: NewsListType;
  page: NewsPageType;
};

export const BlogPage = (props: BlogPageProps) => {
  const { content, page } = props;

  return (
    <main className={s.root}>
      {page?.titleWithIcon && (
        <PageHero
          variant="primary"
          textColor="brown"
          title={page?.titleWithIcon}
        />
      )}
      <FilterPaginationContainer
        initialContent={content}
        filters={[]}
        fetchFunction={getCurrentBlogPosts}
        renderCard={(article) => (
          <ArticleCard
            key={article.documentId}
            data={article}
            basePath="/blog"
          />
        )}
        showFilters={false}
        paginationThreshold={6}
        cardsClassName={cardsGrid.root}
      />
    </main>
  );
};

BlogPage.displayName = "BlogPage";
